import type { Currency } from "api/schemas/shared";

export function getCurrencySymbol(currency: Currency): string {
  const keyMap: Record<Currency, string> = {
    EUR: "€",
    GBP: "£",
    SEK: "kr",
    USD: "$",
  };

  return keyMap[currency] || "";
}
